// src/pages/Home/data/founders.js
import founder1 from "../../../assets/images/v/1.png";
import founder2 from "../../../assets/images/v/2.png";
import founder3 from "../../../assets/images/v/3.png";
import founder4 from "../../../assets/images/v/4.png";

export const getFounders = (lang) => [
  {
    img: founder4,
    name: "Ziad Ramzy Rezk",
    role: "Founder & Business",
    linkedin:
      "https://www.linkedin.com/in/ziad-ramzy1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    note:
      lang === "ar"
        ? "مسؤول عن الاتجاه التجاري وتطوير المشروع وبناء الشراكات."
        : "Responsible for business direction, project development, and partnerships.",
  },
  // {
  //   img: founder2,
  //   name: "Omar Moataz Ahmed",
  //   role: "Backend & Security Software Developer",
  //   linkedin:
  //     "https://www.linkedin.com/in/0mar-moataz?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  //   note:
  //     lang === "ar"
  //       ? "يعمل على أنظمة الباك إند وحلول برمجية مركزة على الأمان."
  //       : "Works on backend systems and security-focused software solutions.",
  // },
  {
    img: founder1,
    name: "Seif Eldein Hazem Hassan",
    role: "Machine Learning Specialist",
    linkedin:
      "https://www.linkedin.com/in/seif-eldein?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    note:
      lang === "ar"
        ? "خبرة في تعلم الآلة وحلول مدعومة بالذكاء الاصطناعي لدفع الابتكار والنمو."
        : "Expertise in Machine Learning and AI-driven solutions to drive growth and innovation.",
  },
  {
    img: founder3,
    name: "Marwan Ahmed Abdel Rahim",
    role: "Mobile Application Developer",
    linkedin:
      "https://www.linkedin.com/in/marwan-ahmed-abdelrehem?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    note:
      lang === "ar"
        ? "يركّز على بناء تطبيقات موبايل سهلة وسلسة وتجربة مستخدم قوية."
        : "Focused on smooth mobile app experiences and strong user-friendly delivery.",
  },
];
